export function stackingCards() {
  const cardsSections = document.querySelectorAll('[data-stacking-cards-init]');

  if (!cardsSections.length) return;

  const currentTier = getCurrentViewportTier();
  window.viewportTier = currentTier;

  ScrollTrigger.getAll().forEach((trigger) => {
    cardsSections.forEach((section) => {
      if (section.contains(trigger.trigger)) {
        trigger.kill();
      }
    });
  });

  cardsSections.forEach((section) => {
    section.querySelectorAll('[data-stacking-card-target], .stacking-cards__watermark-heading').forEach((el) => {
      gsap.killTweensOf(el);
      gsap.set(el, { clearProps: 'all' });
    });
  });

  cardsSections.forEach((section) => {
    const tier = currentTier;

    const isEnabled =
      (tier === 'desktop' &&
        section.dataset.stackingCardsDesktop === 'true') ||
      (tier === 'tablet' &&
        section.dataset.stackingCardsTablet === 'true') ||
      (
        (tier === 'mobile-portrait' || tier === 'mobile-landscape') &&
        section.dataset.stackingCardsMobile === 'true'
      );

    if (!isEnabled) return;

    const cards = Array.from(
      section.querySelectorAll('[data-stacking-card]')
    );

    if (!cards.length) return;

    const watermark = section.querySelector('.stacking-cards__watermark-heading');

    if (watermark) {
      // Fade as the first card crosses the heading at the viewport centre.
      gsap.fromTo(watermark, { opacity: 1 }, {
        opacity: 0.25,
        ease: 'none',
        scrollTrigger: {
          id: 'stacking-watermark',
          trigger: cards[0],
          start: () => `top ${window.innerHeight / 2 + watermark.offsetHeight / 2}px`,
          end: () => `top ${window.innerHeight / 2 - watermark.offsetHeight / 2}px`,
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    }

    const stickyTop =
      parseFloat(getComputedStyle(cards[0]).top) || 0;

    const rotateValues = (() => {
      if (tier === 'desktop') {
        return parseRotateValues(
          section,
          'data-stacking-cards-desktop-rotate'
        );
      }

      if (tier === 'tablet') {
        return parseRotateValues(
          section,
          'data-stacking-cards-tablet-rotate'
        );
      }

      return parseRotateValues(
        section,
        'data-stacking-cards-mobile-rotate'
      );
    })();

    const xValues = (() => {
      if (tier === 'desktop') {
        return parseAxisValues(
          section,
          'data-stacking-cards-desktop-x'
        );
      }

      if (tier === 'tablet') {
        return parseAxisValues(
          section,
          'data-stacking-cards-tablet-x'
        );
      }

      return parseAxisValues(
        section,
        'data-stacking-cards-mobile-x'
      );
    })();

    const yValues = (() => {
      if (tier === 'desktop') {
        return parseAxisValues(
          section,
          'data-stacking-cards-desktop-y'
        );
      }

      if (tier === 'tablet') {
        return parseAxisValues(
          section,
          'data-stacking-cards-tablet-y'
        );
      }

      return parseAxisValues(
        section,
        'data-stacking-cards-mobile-y'
      );
    })();

    cards.forEach((card, index) => {
      const targetEl = card.querySelector(
        '[data-stacking-card-target]'
      );

      if (!targetEl) return;

      const rotate =
        rotateValues[index % rotateValues.length];

      const x =
        xValues[index % xValues.length];

      const y =
        yValues[index % yValues.length];

      gsap.set(targetEl, {
        rotate: 0,
        x: 0,
        y: 0,
        scale: 1,
        zIndex: cards.length - index
      });

      gsap.to(targetEl, {
        rotate,
        x,
        y,
        ease: 'power1.in',
        overwrite: 'auto',
        scrollTrigger: {
          id: `stacking-rotate-${index}`,
          trigger: card,
          start: 'top 75%',
          end: `top-=${stickyTop} top`,
          scrub: true
        }
      });

      ScrollTrigger.create({
        id: `stacking-bounce-${index}`,
        trigger: card,
        start: `top-=${stickyTop} top`,
        onEnter: () => pulseElement(targetEl)
      });
    });
  });

  ScrollTrigger.refresh();

  if (!window._hasStackingResizeListener) {
    let last = getCurrentViewportTier();

    window.addEventListener(
      'resize',
      debounceOnWidthChange(() => {
        const next = getCurrentViewportTier();

        if (last !== next) {
          ScrollTrigger.getAll().forEach((trigger) => {
            if (trigger.vars?.id?.startsWith('stacking')) {
              trigger.kill();
            }
          });

          cardsSections.forEach((section) => {
            section
              .querySelectorAll('[data-stacking-card-target]')
              .forEach((el) => {
                gsap.killTweensOf(el);
                gsap.set(el, {
                  clearProps: 'all'
                });
              });
          });

          stackingCards();
        }

        last = next;
        window.viewportTier = next;
      }, 250)
    );

    window._hasStackingResizeListener = true;
  }
}

function parseRotateValues(section, attr) {
  const fallback = [0, 4, -4];

  const values = (section.getAttribute(attr) || '')
    .split(',')
    .map((value) => parseFloat(value.trim()));

  return values.length >= 1 &&
    values.every((value) => !Number.isNaN(value))
    ? values
    : fallback;
}

function parseAxisValues(section, attr) {
  const raw = section.getAttribute(attr);

  if (!raw) {
    return ['0em', '0em', '0em'];
  }

  const values = raw
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

  return values.length
    ? values
    : ['0em', '0em', '0em'];
}

function getCurrentViewportTier() {
  const width = window.innerWidth;

  if (width <= 479) return 'mobile-portrait';
  if (width <= 767) return 'mobile-landscape';
  if (width <= 991) return 'tablet';

  return 'desktop';
}

function pulseElement(targetEl) {
  const width = targetEl.offsetWidth;
  const height = targetEl.offsetHeight;

  const fontSize = parseFloat(
    getComputedStyle(targetEl).fontSize
  );

  const stretchPx = 1.5 * fontSize;

  const targetScaleX =
    (width + stretchPx) / width;

  const targetScaleY =
    (height - stretchPx * 0.33) / height;

  gsap.timeline()
    .to(targetEl, {
      scaleX: targetScaleX,
      scaleY: targetScaleY,
      duration: 0.1,
      ease: 'power1.out'
    })
    .to(targetEl, {
      scaleX: 1,
      scaleY: 1,
      duration: 1,
      ease: 'elastic.out(1, 0.3)'
    });
}

function debounceOnWidthChange(fn, ms) {
  let last = window.innerWidth;
  let timer;

  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      if (window.innerWidth === last) return;

      last = window.innerWidth;
      fn.apply(this, args);
    }, ms);
  };
}
